import React, { useState, useEffect, useRef } from "react";
import { getAssets } from "@unisearch/helpers";
import { useInView } from "react-intersection-observer";
import styles from "./connect.module.scss";

export const UniPageLandingConnect = () => {
  // const boxRef = useRef();
  // const [scrollPosition, setScrollPosition] = useState(0);
  // const [gap, setScrollPGap] = useState(0);

  // useEffect(() => {
  //   const currentPosition = boxRef.current.offsetTop;
  //   const scrollPosition = window.pageYOffset;
  //   const gap = (currentPosition - scrollPosition)

  //   setScrollPGap(gap)
  // }, []);

  // useEffect(() => {
  //   window.addEventListener("scroll", handleScroll);

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);

  //   const handleScroll = () => {
  //     const position = window.pageYOffset;
  //     const y = boxRef.current.offsetTop;
  //     const h = boxRef.current.clientHeight;
  //     const size = position - y;
  //     setScrollPosition(size);
  //   };

  return (
    <section className={styles.section_connect}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.heading_wrapper}>
            <h2 className={styles.heading}>
              <span className={styles.heading_small}>
                How Does UniSearch Connect
              </span>
              <br />
              You to Your Best-Fit Prospects?
            </h2>
          </div>

          {/* item */}
          <div className={styles.best_fit_container}>
            {/* <div className={styles.arrow} style={{height:0 }}></div> */}
            <div className={styles.best_fit_wrapper}>
              <div className={styles.best_fit_left}>
                <div
                  className={`${styles.image_wrapper} ${styles.aligh_right}`}
                >
                  <img
                    src={getAssets(
                      "assets/images/unipage/Manage Student Touchpoints.png"
                    )}
                    alt="Manage Student Touchpoints"
                  />
                </div>
              </div>
              <div className={styles.best_fit_right}>
                <h5>Manage Student Touchpoints</h5>
                <p>
                  Optimise all student points of contact, from program
                  information to blogs and rich media, with data-driven
                  engagement insights.
                </p>
              </div>
            </div>

            {/* item */}
            <div className={styles.best_fit_wrapper}>
              <div className={styles.best_fit_left}>
                <h5>View Most-Engaged Prospects</h5>
                <p>
                  Get real-time alerts when students add your programs to
                  Favourites, download course content, and more.
                </p>
              </div>
              <div className={styles.best_fit_right}>
                <div className={`${styles.image_wrapper}`}>
                  <img
                    src={getAssets(
                      "assets/images/unipage/View Most-Engaged Prospects.png"
                    )}
                    alt="View Most-Engaged Prospects"
                  />
                </div>
              </div>
            </div>

            {/* item */}
            <div className={styles.best_fit_wrapper}>
              <div className={styles.best_fit_left}>
                <div
                  className={`${styles.image_wrapper} ${styles.aligh_right}`}
                >
                  <img
                    src={getAssets(
                      "assets/images/unipage/Access Student Profiles Directly.png"
                    )}
                    alt="Access Student Profiles Directly"
                  />
                </div>
              </div>
              <div className={styles.best_fit_right}>
                <h5>Access Student Profiles Directly</h5>
                <p>
                  Verify whether profile-matched, most-engaged students are your
                  best-fit prospects through individual profile access.
                </p>
              </div>
            </div>

            {/* item */}
            <div className={styles.best_fit_wrapper}>
              <div className={styles.best_fit_left}>
                <h5>Personalise Program Suggestions</h5>
                <p>
                  Send individual prospects tailored program recommendations
                  based on their detailed student profile.
                </p>
              </div>
              <div className={styles.best_fit_right}>
                <div className={`${styles.image_wrapper}`}>
                  <img
                    src={getAssets(
                      "assets/images/unipage/Personalise Program Suggestions.png"
                    )}
                    alt="Personalise Program Suggestions"
                  />
                </div>
              </div>
            </div>

            {/* item */}
            <div className={styles.best_fit_wrapper}>
              <div className={styles.best_fit_left}>
                <div
                  className={`${styles.image_wrapper} ${styles.aligh_right}`}
                >
                  <img
                    src={getAssets(
                      "assets/images/unipage/Engage Students One-to-One.png"
                    )}
                    alt="Engage Students One-to-One"
                  />
                </div>
              </div>
              <div className={styles.best_fit_right}>
                <h5>Engage Students One-to-One</h5>
                <p>
                  Connect with students directly through one-to-one, real-time
                  chat.
                </p>
              </div>
            </div>

            {/* item */}
            <div className={styles.best_fit_wrapper}>
              <div className={styles.best_fit_left}>
                <h5>Appoint International Student Mentors</h5>
                <p>
                  Engage students through the experiences of your international
                  student community by connecting student mentors with
                  prospects.
                </p>
              </div>
              <div className={styles.best_fit_right}>
                <div className={`${styles.image_wrapper}`}>
                  <img
                    src={getAssets(
                      "assets/images/unipage/Appoint International Student Mentors.png"
                    )}
                    alt="Appoint International Student Mentors"
                  />
                </div>
              </div>
            </div>

            {/* item */}
            <div className={styles.best_fit_wrapper}>
              <div className={styles.best_fit_left}>
                <div
                  className={`${styles.image_wrapper} ${styles.aligh_right}`}
                >
                  <img
                    src={getAssets(
                      "assets/images/unipage/Collaborate with Regional Experts.png"
                    )}
                    alt="Collaborate with Regional Experts"
                  />
                </div>
              </div>
              <div className={styles.best_fit_right}>
                <h5>Collaborate with Regional Experts</h5>
                <p>
                  Create focused recruitment strategies for distinct markets
                  with the support of dedicated regional teams, from local
                  market insight to partnership opportunities with target market
                  institutions.
                </p>
              </div>
            </div>

            {/* item */}
            <div className={styles.best_fit_wrapper}>
              <div className={styles.best_fit_left}>
                <h5>Enhanced Recruitment Outcomes</h5>
                <p>
                  Turn access to a simplified and streamlined enrolment
                  pipeline, 360-degree engagement with students, and
                  comprehensive post-application support into higher conversion
                  and completion rates.
                </p>
              </div>
              <div className={styles.best_fit_right}>
                <div className={`${styles.image_wrapper}`}>
                  <img
                    src={getAssets(
                      "assets/images/unipage/Enhanced Recruitment Outcomes.png"
                    )}
                    alt="Enhanced Recruitment Outcomes"
                  />
                </div>
              </div>
            </div>
            {/* item end */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniPageLandingConnect;
